module.exports = __webpack_public_path__ + "img/login_placeholder_blue_theme.f049b99b.svg";